import { computed, observable } from 'mobx';
import IcoImport from './IcoImport';
import type { IIco } from '../types/api';

class IcoImportList {
  @observable icoImports: IcoImport[];

  constructor(icos: IIco[]) {
    this.icoImports = icos.map(
      ({ id, identifier, weight, ico_import }) =>
        new IcoImport({
          ...ico_import,
          identifier,
          id,
          weight,
          in_netsuite: ico_import?.in_netsuite ?? false,
          is_internal_contract: ico_import?.is_internal_contract ?? false,
          is_pending_submission_to_netsuite:
            ico_import?.is_pending_submission_to_netsuite ?? false,
        })
    );
  }

  @computed get isFinalized() {
    return this.icoImports.every((icoImport) => icoImport.isClosed);
  }
}

export default IcoImportList;
